"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineEnumerableProperties = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineEnumerableProperties");

var _defineProperty = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThen = getThen;
exports.toIterablePromise = toIterablePromise;
exports.memoizeIterable = memoizeIterable;

var _iterableUtils = require("./iterableUtils");
/**
 * Lazily returns the `then` function of the created promise.
 */


function getThen(createPromise) {
  return function (onResolved, onRejected) {
    return createPromise().then(onResolved, onRejected);
  };
}
/**
 * Returns an iterable that is also a promise to the first element.
 */


function toIterablePromise(iterable) {
  var _then, _ref, _mutatorMap;

  // If called with a generator function,
  // memoize it to enable multiple iterations
  if (typeof iterable === 'function') iterable = memoizeIterable(iterable()); // Return an object that is iterable and a promise

  return _ref = {}, _defineProperty(_ref, Symbol.asyncIterator, function () {
    return iterable[Symbol.asyncIterator]();
  }), _then = "then", _mutatorMap = {}, _mutatorMap[_then] = _mutatorMap[_then] || {}, _mutatorMap[_then].get = function () {
    var _this = this;

    return getThen(function () {
      return (0, _iterableUtils.getFirstItem)(_this);
    });
  }, _defineProperty(_ref, "catch", function _catch(onRejected) {
    return this.then(null, onRejected);
  }), _defineProperty(_ref, "finally", function _finally(callback) {
    return this.then().finally(callback);
  }), _defineEnumerableProperties(_ref, _mutatorMap), _ref;
}
/**
 * Returns a memoized version of the iterable
 * that can be iterated over as many times as needed.
 */


function memoizeIterable(iterable) {
  var cache = [];
  var iterator = iterable[Symbol.asyncIterator]();
  return _defineProperty({}, Symbol.asyncIterator, function () {
    var i = 0;
    return {
      next: function () {
        var _next = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var item;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(i < cache.length)) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return", cache[i++]);

                case 2:
                  if (iterator) {
                    _context.next = 4;
                    break;
                  }

                  return _context.abrupt("return", {
                    done: true
                  });

                case 4:
                  // Read and cache an item from the iterable otherwise
                  item = cache[i++] = iterator.next();
                  _context.next = 7;
                  return item;

                case 7:
                  if (!_context.sent.done) {
                    _context.next = 9;
                    break;
                  }

                  iterator = null;

                case 9:
                  return _context.abrupt("return", item);

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function next() {
          return _next.apply(this, arguments);
        }

        return next;
      }()
    };
  });
}